import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN;
const release = process.env.SENTRY_RELEASE;

Sentry.init({
  dsn:
    SENTRY_DSN ||
    'https://8afcab0259ecef6cff6f779b9c7ea6a3@sentry.manjuu.com/15',
  tracesSampleRate: 1.0,
  environment: process.env.APP_ENV,
  release,
});
// export {};
